module.exports = __webpack_public_path__ + "static/media/logo.650d30d0.svg";